<template>
  <div class="step-header">
    <h2 class="step-title">
      {{ title }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'StepHeader',
  props: {
    currentStep: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      if (this.currentStep.step_type === 1 && this.currentStep.data.yes_no_question) {
        return this.currentStep.data.yes_no_question;
      }
      return this.currentStep.name;
    }
  }
};
</script>

<style scoped>
.step-header {
  @apply tw-px-8 tw-pt-6 tw-pb-2;
}

.step-title {
  @apply tw-text-2xl tw-font-semibold tw-text-gray-800;
  @apply tw-leading-tight;
}

@media (max-width: 768px) {
  .step-header {
    @apply tw-px-6;
  }
  
  .step-title {
    @apply tw-text-xl;
  }
}
</style>
